<div class="d-flex justify-content-center">
  <div class="col-12">
    @if (job()) {
      <div>
        <jhi-alert-error></jhi-alert-error>
        <jhi-alert></jhi-alert>
        <h4>
          <span>{{ job()!.title }}</span>
        </h4>

        <hr />
        <div [innerHTML]="job()!.description"></div>
        <hr />
        <div class="text-center">
          <button type="button" [routerLink]="['/job/public', job()!.id, 'apply']" class="btn btn-primary btn-lg">
            <span>Apply This Job</span>
          </button>
        </div>
      </div>
    }
  </div>
</div>
